/**
 * Schaltet eine CSS-Klasse auf einem Element ein oder aus,
 * sofern das Element vorhanden ist.
 */
export function toggleClass(el, className) {
    if(el){
        el.classList.toggle(className);
    }
}

/**
 * Startet den Browser-Druckdialog für die aktuelle Seite.
 */
export function printWeekly(){
    window.print();
}